import axios from "axios"

// URL-ul de bază pentru Laravel API
const API_URL = "https://apex-front.sitemile.com/api"

const axiosApi = axios.create({
  baseURL: API_URL,
})

// Interceptor pentru Cereri (Requests)
// Acesta rulează înainte de fiecare cerere HTTP
axiosApi.interceptors.request.use(
  (config) => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser && authUser.token) {
      // Adăugăm Bearer Token-ul din localStorage în header-ul de Authorization
      config.headers["Authorization"] = `Bearer ${authUser.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor pentru Răspunsuri (Responses)
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Dacă primim 401 (Unauthorized), înseamnă că token-ul a expirat
    if (error.response && error.response.status === 401) {
      // Opțional: Poți curăța localStorage aici dacă vrei să forțezi login-ul
      // localStorage.removeItem("authUser");
    }
    return Promise.reject(error);
  }
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}


export async function post_new(url, data, config = {}) {
  // REMOVE the { ...data } spread. Pass 'data' directly.
  return axiosApi
    .post(url, data, config) 
    .then(response => response.data)
}

export async function put_new(url, data, config = {}) {
  // REMOVE the { ...data } spread. Pass 'data' directly.
  return axiosApi
    .put(url, data, config)
    .then(response => response.data)
}